import React from "react";
import { GenericPage } from "../../../../../pages";

import { creditorRoutes } from "./finanzas-creditors.route";
import { expenseRoutes } from "./finanzas-expenses.route";
import { cashRegisterRoutes } from "./finanzas-cash-register.route";
import { accountReceivableRoutes } from "./finanzas-account-receivable.route";
import { accountPayableRoutes } from "./finanzas-account-payable.route";
import { creditNoteRoutes } from "./finanzas-credit-note.route";
import { debitNoteRoutes } from "./finanzas-debit-note.route";

export const finanzasRoutes = [
  {
    path: "account-receivable",
    element: <GenericPage />,
    children: accountReceivableRoutes,
  },
  {
    path: "account-payable",
    element: <GenericPage />,
    children: accountPayableRoutes,
  },
  {
    path: "debit-note",
    element: <GenericPage />,
    children: debitNoteRoutes,
  },
  {
    path: "cash-register",
    element: <GenericPage />,
    children: cashRegisterRoutes,
  },
  {
    path: "creditors",
    element: <GenericPage />,
    children: creditorRoutes,
  },
  {
    path: "credit-note",
    element: <GenericPage />,
    children: creditNoteRoutes,
  },
  {
    path: "expenses",
    element: <GenericPage />,
    children: expenseRoutes,
  },
];
